import React, { useEffect, forwardRef, useState } from 'react';

import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import MobileDatePicker from '@mui/lab/MobileDatePicker';
import MobileTimePicker from '@mui/lab/MobileTimePicker';
import TextField from '@mui/material/TextField';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import MenuItem from '@mui/material/MenuItem';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Slide from '@mui/material/Slide';

import esLocale from 'date-fns/locale/es';
import moment from "moment";
import "moment/locale/es";

import Loader from "components/Loader/Loader";

import { Redirect } from 'react-router-dom';

moment.locale("es");

const Alert = forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const Transition = forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

function Captura(){
    const [color, setColor] = useState("");
    const [message, setMessage] = useState("");
    const [openSnackbar, setOpenSnackbar] = useState(false);

    const [load, setLoad] = useState(false);

    const [Fecha, setFecha] = useState(new Date());
    const [Hora, setHora] = useState("");
    const [Nombre, setNombre] = useState("");
    const [Correo, setCorreo] = useState("");
    const [Telefono, setTelefono] = useState("");
    const [RFC, setRFC] = useState("");
    const [MarcaDispositivo, setMarcaDispositivo] = useState("");
    const [ModeloDispositivo, setModeloDispositivo] = useState("");
    const [VersionApp, setVersionApp] = useState("");
    const [VersionSO, setVersionSO] = useState("");
    const [SistemaOperativo, setSistemaOperativo] = useState("");
    const [IdEstatusError, setIdEstatusError] = useState("40");
    const [IdEstatusFlujo, setIdEstatusFlujo] = useState("20");
    const [PasosEjecutados, setPasosEjecutados] = useState("");
    const [IdEstatusIncidencia, setIdEstatusIncidencia] = useState("1");

    const [EstatusError, setEstatusError] = useState([]);
    const [EstatusFlujo, setEstatusFlujo] = useState([]);
    const [EstatusIncidencia, setEstatusIncidencia] = useState([]);

    const [FechaError, setFechaError] = useState(false);
    const [HoraError, setHoraError] = useState(false);
    const [NombreError, setNombreError] = useState(false);
    const [CorreoError, setCorreoError] = useState(false);
    const [TelefonoError, setTelefonoError] = useState(false);
    const [RFCError, setRFCError] = useState(false);
    const [MarcaDispositivoError, setMarcaDispositivoError] = useState(false);
    const [ModeloDispositivoError, setModeloDispositivoError] = useState(false);
    const [VersionAppError, setVersionAppError] = useState(false);
    const [VersionSOError, setVersionSOError] = useState(false);
    const [SistemaOperativoError, setSistemaOperativoError] = useState(false);
    const [PasosEjecutadosError, setPasosEjecutadosError] = useState(false);

    const validaCampos = () => {
        let error = false;

        setFechaError(false);
        setHoraError(false);
        setNombreError(false);
        setCorreoError(false);
        setTelefonoError(false);
        setRFCError(false);
        setMarcaDispositivoError(false);
        setModeloDispositivoError(false);
        setVersionAppError(false);
        setVersionSOError(false);
        setSistemaOperativoError(false);
        setPasosEjecutadosError(false);

        //if(Fecha === null){
        //    setFechaError(true);
        //    error = true;
        //}
        //if(Hora === ''){
        //    setHoraError(true);
        //    error = true;
        //}
        if(Nombre === ''){
            setNombreError(true);
            error = true;
        }
        if(Correo === ''){
            setCorreoError(true);
            error = true;
        }
        if(Telefono === ''){
            setTelefonoError(true);
            error = true;
        }
        if(RFC === ''){
            setRFCError(true);
            error = true;
        }
        if(MarcaDispositivo === '' && IdEstatusIncidencia === 2){
            setMarcaDispositivoError(true);
            error = true;
        }
        if(ModeloDispositivo === '' && IdEstatusIncidencia === 2){
            setModeloDispositivoError(true);
            error = true;
        }
        if(VersionApp === '' && IdEstatusIncidencia === 2){
            setVersionAppError(true);
            error = true;
        }
        if(VersionSO === '' && IdEstatusIncidencia === 2){
            setVersionSOError(true);
            error = true;
        }
        if(SistemaOperativo === '' && IdEstatusIncidencia === 2){
            setSistemaOperativoError(true);
            error = true;
        }
        if(PasosEjecutados === '' && IdEstatusIncidencia === 2){
            setPasosEjecutadosError(true);
            error = true;
        }

        return error;
    };

    const validateEmail = (email) => {
        const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
    };

    const correoChange = (event) => {
        setCorreo(event.target.value);

        if(!validateEmail(event.target.value)){
            setCorreoError(true);
        } else {
            setCorreoError(false);
        }
    };

    const sendSnackBar = (pmessage, pcolor) => {
        setOpenSnackbar(true);
        setColor(pcolor);
        setMessage(pmessage);
    };

    const SnackbarClose = (event, reason) => {
        if (reason === 'clickaway') {
          return;
        }
    
        setOpenSnackbar(false);
    };

    const Login = async () => {
        let dataResponse;
        try {
            let header = {
                method: "POST",
                body: JSON.stringify({UserName: process.env.REACT_APP_USER, Password: process.env.REACT_APP_PASS}),
                headers: {
                    "Content-Type": "application/json"
                }
            };

            let response = await fetch(
                process.env.REACT_APP_URL_APICORE + "Login",
                header
            );

            dataResponse = await response.json();
        } catch (error) {
            sendSnackBar("Error de conexión", "error");
        }
    
        return dataResponse;
    };

    const InsertaCapturaIncidencia = async (data, token) => {
        let dataResponse;
        try {
            let header = {
                method: "POST",
                body: JSON.stringify(data),
                headers: {
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + token
                }
            };
    
            let response = await fetch(
                process.env.REACT_APP_URL_APICORE + "CapturaIncidencia/InsertaCapturaIncidencia",
                header
            );

            dataResponse = await response.json();
        } catch (error) {
            sendSnackBar("Error de conexión", "error");
        }
    
        return dataResponse;
    };

    const ObtieneEstatusIncidencia = async (token) => {
        let dataResponse;
        try {
            let header = {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + token
                }
            };
    
            let response = await fetch(
                process.env.REACT_APP_URL_APICORE + "CapturaIncidencia/ObtieneEstatusIncidencia",
                header
            );

            dataResponse = await response.json();
        } catch (error) {
            sendSnackBar("Error de conexión", "error");
        }
    
        return dataResponse;
    };

    const ObtieneEstatusFlujo = async (token) => {
        let dataResponse;
        try {
            let header = {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + token
                }
            };
    
            let response = await fetch(
                process.env.REACT_APP_URL_APICORE + "CapturaIncidencia/ObtieneEstatusFlujo",
                header
            );

            dataResponse = await response.json();
        } catch (error) {
            sendSnackBar("Error de conexión", "error");
        }
    
        return dataResponse;
    };

    const ObtieneEstatusError = async (token) => {
        let dataResponse;
        try {
            let header = {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + token
                }
            };
    
            let response = await fetch(
                process.env.REACT_APP_URL_APICORE + "CapturaIncidencia/ObtieneEstatusError",
                header
            );

            dataResponse = await response.json();
        } catch (error) {
            sendSnackBar("Error de conexión", "error");
        }
    
        return dataResponse;
    };

    const ValidaDatos = () => {
        let datos = { Fecha, Hora: "00:00:00", Nombre, Correo, Telefono, RFC, MarcaDispositivo, 
            ModeloDispositivo, VersionApp, VersionSO, SistemaOperativo, IdEstatusError: IdEstatusError.toString(), 
            IdEstatusFlujo: IdEstatusFlujo.toString(), PasosEjecutados, IdEstatusIncidencia: IdEstatusIncidencia.toString(),
            IdUsuario: parseInt(getUser()) };
        if(!validaCampos()){
            return datos;
        } else {
            return { error: true }
        }
    }

    const getUser = () => {
        return JSON.parse(localStorage.getItem("userICR")).IdUsuario;
    };

    const EnviaDatos = () => {
        try{
            setLoad(true);
            
            let datos = ValidaDatos();
            
            if(datos.error === undefined){
                Login()
                .then(result => {
                    InsertaCapturaIncidencia(datos, result.token)
                    .then(result => {
                        if(result.success){
                            sendSnackBar("Registro exitoso", "success");
                            setOpenSnackbar(true);
                            LimpiaValores();
                        } else {
                            sendSnackBar("Error de conexión", "error");
                            LimpiaValores();
                        }
        
                        setLoad(false);
                    });
                });
            } else {
                sendSnackBar("Todos los valores son obligatorios", "error");
                setLoad(false);
            }
        } catch(error){
            sendSnackBar("Error de conexión", "error");
            setLoad(false);
        }
    };

    const LimpiaValores = () => {
        setFecha(new Date());
        setHora("");
        setNombre("");
        setCorreo("");
        setTelefono("");
        setRFC("");  
        setMarcaDispositivo("");
        setModeloDispositivo("");
        setVersionApp("");
        setVersionSO("");
        setSistemaOperativo("");
        setIdEstatusError("40");
        setIdEstatusFlujo("20");
        setPasosEjecutados("");
        setIdEstatusIncidencia("1");
    };

    const GetIdUsuario = () => {
        return JSON.parse(localStorage.getItem('userICR')).IdUsuario;
    };
    
    const UsuarioActivo = async (data, token) => {
        let dataResponse;
        try {
            let header = {
                method: "POST",
                body: JSON.stringify(data),
                headers: {
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + token
                }
            };

            let response = await fetch(
                process.env.REACT_APP_URL_APICORE + "Usuario/UsuarioActivo",
                header
            );

            dataResponse = await response.json();
        } catch (error) {
            sendSnackBar("Error de conexión", "error");
        }

        return dataResponse;
    };

    useEffect(() => {
        Login()
        .then(result => {
            let token = result.token;

            if(result !== undefined) {
                UsuarioActivo({ IdUsuario: GetIdUsuario() },token)
                .then(result => {
                console.log(result);
                if(result.activo === false){
                    localStorage.removeItem("userICR");
                    return <Redirect to='/admin'/>;
                }
                });
            } else {
                sendSnackBar("Error de conexión", "error");
            }
        });

        Login()
        .then(result => {
            if(result !== undefined){
                ObtieneEstatusIncidencia(result.token)
                .then(result => {
                    setEstatusIncidencia(result.estatus);
                });

                ObtieneEstatusFlujo(result.token)
                .then(result => {
                    setEstatusFlujo(result.estatus);
                });

                ObtieneEstatusError(result.token)
                .then(result => {
                    setEstatusError(result.estatus);
                }).catch(error => sendSnackBar("Error de conexión", "error"));
            } else {
                sendSnackBar("Error de conexión", "error");
            }
        }).catch(error => sendSnackBar("Error de conexión", "error"));
    }, []);

    return (
        <>
            <Card style={{ marginBottom: "30px" }}>
                <Grid container spacing={3} style={{ padding: "30px" }}>
                    <Grid item xs={12} sm={12} xl={12}>
                        <Typography variant="h6">
                            Datos
                        </Typography>
                    </Grid>
                    <Grid item xs={12} sm={6} xl={4}>
                        <TextField value={Nombre} onChange={(event) => setNombre(event.target.value)}  label="Nombre" variant="outlined" style={{ width: "100%" }} inputProps={{ maxlength: 255 }} error={NombreError} /> 
                    </Grid>
                    <Grid item xs={12} sm={6} xl={4}>
                        <TextField value={Correo} onChange={(event) => correoChange(event)}  label="Correo" variant="outlined" style={{ width: "100%" }} inputProps={{ maxlength: 100 }} error={CorreoError} /> 
                    </Grid>
                    <Grid item xs={12} sm={6} xl={4}>
                        <TextField value={Telefono} onChange={(event) => setTelefono(event.target.value)}  label="Teléfono" variant="outlined" style={{ width: "100%" }} inputProps={{ maxlength: 10 }} error={TelefonoError} /> 
                    </Grid>
                    <Grid item xs={12} sm={6} xl={4}>
                        <TextField value={RFC} onChange={(event) => setRFC(event.target.value)} label="RFC" variant="outlined" style={{ width: "100%" }} inputProps={{ maxlength: 13 }} error={RFCError} /> 
                    </Grid>
                    <Grid item xs={12} sm={6} xl={4}>
                        <TextField value={MarcaDispositivo} onChange={(event) => setMarcaDispositivo(event.target.value)} label="Marca dispositivo" variant="outlined" style={{ width: "100%" }} inputProps={{ maxlength: 45 }} error={MarcaDispositivoError} /> 
                    </Grid>
                    <Grid item xs={12} sm={6} xl={4}>
                        <TextField value={ModeloDispositivo} onChange={(event) => setModeloDispositivo(event.target.value)} label="Modelo dispositivo" variant="outlined" style={{ width: "100%" }} inputProps={{ maxlength: 45 }} error={ModeloDispositivoError}  /> 
                    </Grid>
                    <Grid item xs={12} sm={6} xl={4}>
                        <TextField value={VersionApp} onChange={(event) => setVersionApp(event.target.value)} label="Versión app" variant="outlined" style={{ width: "100%" }} inputProps={{ maxlength: 10 }} error={VersionAppError}  /> 
                    </Grid>
                    <Grid item xs={12} sm={6} xl={4}>
                        <TextField value={VersionSO} onChange={(event) => setVersionSO(event.target.value)} label="Versión SO" variant="outlined" style={{ width: "100%" }} inputProps={{ maxlength: 10 }} error={VersionSOError}  /> 
                    </Grid>
                    <Grid item xs={12} sm={6} xl={4}>
                        <TextField value={SistemaOperativo} onChange={(event) => setSistemaOperativo(event.target.value)} label="Sistema Operativo" variant="outlined" style={{ width: "100%" }} inputProps={{ maxlength: 10 }} error={SistemaOperativoError}  /> 
                    </Grid>
                </Grid>
            </Card>
            <Card style={{ marginBottom: "30px" }}>
                <Grid container spacing={3} style={{ padding: "30px" }}>
                    <Grid item xs={12} sm={12} xl={12}>
                        <Typography variant="h6">
                            Estatus
                        </Typography>
                    </Grid>
                    <Grid item xs={12} sm={6} xl={4}>
                        <TextField
                            select
                            label="Código error"
                            value={IdEstatusError} 
                            onChange={(event) => setIdEstatusError(event.target.value)} 
                            style={{ width: "100%" }}
                        >
                            {EstatusError.map((option) => (
                                <MenuItem key={option.IdEstatusError} value={option.IdEstatusError}>
                                    {option.Nombre}
                                </MenuItem>
                            ))}
                        </TextField>
                    </Grid>
                    <Grid item xs={12} sm={6} xl={4}>
                        <TextField
                            select
                            label="Flujo en el que aparece"
                            value={IdEstatusFlujo} 
                            onChange={(event) => setIdEstatusFlujo(event.target.value)} 
                            style={{ width: "100%" }}
                        >
                            {EstatusFlujo.map((option) => (
                                <MenuItem key={option.IdEstatusFlujo} value={option.IdEstatusFlujo}>
                                    {option.Nombre}
                                </MenuItem>
                            ))}
                        </TextField>
                    </Grid>
                    <Grid item xs={12} sm={6} xl={4}>
                        <TextField value={PasosEjecutados} onChange={(event) => setPasosEjecutados(event.target.value)} label="Pasos ejecutados" variant="outlined" style={{ width: "100%" }} inputProps={{ maxlength: 400 }} error={PasosEjecutadosError}  /> 
                    </Grid>
                    <Grid item xs={12} sm={6} xl={4}>
                        <TextField
                            select
                            label="Estatus"
                            value={IdEstatusIncidencia} 
                            onChange={(event) => setIdEstatusIncidencia(event.target.value)} 
                            style={{ width: "100%" }}
                        >
                            {EstatusIncidencia.map((option) => (
                                <MenuItem key={option.IdEstatusIncidencia} value={option.IdEstatusIncidencia}>
                                    {option.Nombre}
                                </MenuItem>
                            ))}
                        </TextField>
                    </Grid>
                </Grid>
            </Card>
            <Grid container
                direction="row-reverse"
                justifyContent="flex-start"
                alignItems="center">
                <Grid item xs={12} sm={12} xl={3}>
                    <Button
                        color="info"
                        variant="contained"
                        onClick={EnviaDatos}
                        style={{ float: "right" }}
                        size="large"
                        >
                            { "Enviar" }
                    </Button>
                </Grid>
            </Grid>
            <Snackbar anchorOrigin={{ vertical: "bottom", horizontal: "right" }} open={openSnackbar} onClose={SnackbarClose} autoHideDuration={6000}>
                <Alert onClose={SnackbarClose} severity={color} sx={{ width: '100%' }}>
                    {message}
                </Alert>
            </Snackbar>
            <Loader load={load} />
        </>
    );
}

export default Captura;